<template>
  <div>
    <!-- 注释弹框 -->
    <van-popup
      v-model="show"
      :overlay="false"
      round
      closeable
      close-icon="cross"
      position="bottom"
      :style="{ height: '90%' }"
    >
      <div class="notes">
        <h1>{{notesText.h1}}</h1>
        <p>
          {{notesText.p}}
        </p>
      </div>
    </van-popup>
  </div>
</template>
<script>
export default {
  name:"Notes",
  props: {
    notesText: {
      type: Object,
    },
  },
  data() {
    return {
      show: false,
    };
  },
  methods: {
    ishow() {
      this.show = true;
    },
  },
};
</script>
<style lang="less" scoped>
.notes {
  font-family: @family;
  padding: 40px 24px;
  h1 {
    font-size: 15PX;
    font-weight: 500;
    color: #2f354d;
    line-height: 22px;
    margin-bottom: 10px;
  }
  p {
    font-size: 13px;
    font-weight: 400;
    color: #5f697d;
    line-height: 24px;
  }
}
</style>
